/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TDoNotDisturbModel,
  IDoNotDisturbRequest,
  IMappers,
  IDoNotDisturbResponse,
  IDoNotDisturbResponseError,
  TDoNotDisturbResponse,
} from './types';

const defaultConfig: TDoNotDisturbModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'quiz',
  pathApi: '/v1/do-not-disturb/',
  hostType: 'api',
} as TDoNotDisturbModel;

function createDoNotDisturbModel(parameters: IDoNotDisturbRequest): TDoNotDisturbModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDoNotDisturbOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IDoNotDisturbRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchDoNotDisturb<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IDoNotDisturbOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TDoNotDisturbResponse> {
  const { response, statusCode } = await httpApi.fetch(createDoNotDisturbModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDoNotDisturbResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IDoNotDisturbResponseError);
    }
  }

  return { response, statusCode } as TDoNotDisturbResponse;
}

export { defaultConfig, createDoNotDisturbModel, fetchDoNotDisturb };
